
function NotFound() {
    return (
        <div>Hmmm we can't seem to find that one
        </div>
    );
}

export {NotFound};